<template>
  <div ref="pdfContent" class="pdf-content">
    <Loader v-if="isLoadingData" fullPage useOverlay loader="spinner"></Loader>
  </div>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
import Loader from "@/components/Loader/Loader";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { EventBus } from "./eventBus";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_CGC } from "../../../../api/api-paths";

let APIDomain = new URL(window.location.href);
if (APIDomain.hostname != "localhost") {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
}

export default {
  components: {
    Loader,
  },
  name: "GeneratePDF",
  data() {
    return {
      name: "PrintBA",
      isLoadingData: false,
      currentDate: this.formatDate(new Date()),
      imageUrl: "",
      dataList: null,
      imageSrc: "", // Base64 data of the image
    };
  },
  created() {
    this.imgLogo();
    EventBus.$on("open-print-ba-list", (data) => {
      this.loadData(data);
    });
  },
  methods: {

    formatDate(date) {
      const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const day = date.getDate();
      const month = months[date.getMonth()];
      return `${day} ${month}`;
    },
    loadData(id) {
      this.isLoadingData = true;
      fnPOST(APIPATH_CGC.getListAuditDetailPdf, {
        id: id,
      })
        .then((response) => {
          this.isLoadingData = false;
          this.dataList = response.data.payload;
          this.generatePdf();
        })
        .finally(() => {
          this.isLoadingData = false;
        });
      //load data berdasarkan id jika diperlukan
    },
    async convertImage(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error("Error converting image:", error);
        return null;
      }
    },

    formatTanggalHariIndo(dateString) {
      let tanggal = new Date(dateString);

      if (dateString == '' || isNaN(tanggal) || dateString == null) {
         tanggal = new Date();
      }

      const hari = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
      ];

      const bulan = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];

      const namaHari = hari[tanggal.getDay()];
      const tgl = tanggal.getDate();
      const bln = bulan[tanggal.getMonth()];
      const thn = tanggal.getFullYear();

      return `${tgl} ${bln} ${thn}`;
    },
    formatTanggalIndo(dateString) {
      const tanggal = new Date(dateString);
      if (dateString == '' || isNaN(tanggal) || dateString == null) {
        return ' ';
      }

      const hari = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
      ];

      const bulan = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];

      const namaHari = hari[tanggal.getDay()];
      const tgl = tanggal.getDate();
      const bln = bulan[tanggal.getMonth()];
      const thn = tanggal.getFullYear();

      return `${tgl} ${bln} ${thn}`;
    },

    formatWaktuIndo(dateValue) {
      const tanggal = new Date(dateValue);

      if (dateValue == '' || isNaN(tanggal) || dateValue == null) {
        return ' ';
      }

      let jam = tanggal.getHours();
      let menit = tanggal.getMinutes();

      // Tambahkan leading zero
      if (jam < 10) jam = "0" + jam;
      if (menit < 10) menit = "0" + menit;

      return `${jam}:${menit}`;
    },

    imgLogo() {
      let APIDomain = new URL(window.location.href);
      let APIPort = "8005";
      let protocol = "https://";
      let APIUrl = protocol + APIDomain.hostname + ":" + APIPort;
      if (APIDomain.hostname == "localhost") {
        APIUrl = "https://testapps.bbi-apparel.com:8005";
      }
      this.imageUrl = APIUrl + "/media/bbi-logo.png";
    },

    async generatePdf() {
      this.imageSrc = await this.convertImage(this.imageUrl);

      const tanggalMulaiDate = this.formatTanggalHariIndo(this.dataList[0].assign_date);
      const tanggalMulai = this.formatTanggalIndo(this.dataList[0].assign_date);
      const tanggalSelesai = this.formatTanggalIndo(
        this.dataList[0].finish_date
      );
      const selesaiOpname = this.formatWaktuIndo(this.dataList[0].finish_date);
      const mulaiOpname = this.formatWaktuIndo(this.dataList[0].assign_date);

      // generate rows from your data
      const rows = this.dataList.map((item, i) => [
        { text: i + 1, alignment: "center" },
        item.brand || "",
        item.category || "",
        item.article || "",
        item.qty_past !== null ? item.qty_past : "",
        item.actual_past !== null ? item.actual_past : "",
        item.qty !== null ? item.qty : "",
        item.qty_plan !== null ? item.qty_plan : "",
        {
          text: item.actual_qty !== null ? item.actual_qty : "",
          fillColor: "#ffff99",
        },
        item.qty_selisih !== null ? item.qty_selisih : "",
        item.remark || "",
      ]);

      const docDefinition = {
        pageMargins: [15, 15, 15, 25],
        pageSize: "A4",
        pageOrientation: "landscape", // <--- THIS MAKES IT LANDSCAPE
        footer: function (currentPage, pageCount) {
          return {
            text: currentPage + " / " + pageCount,
            alignment: "right",
            margin: [0, 0, 20, 20],
            fontSize: 10,
          };
        },

        content: [
          // ================== HEADER ====================
          {
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    text: "BERITA ACARA VALIDASI INVENTORY BBI",
                    alignment: "center",
                    bold: true,
                    fontSize: 14,
                    margin: [0, 0, 0, 10],
                  },
                ],
              ],
            },
            layout: "noBorders",
          },

          // ================== STORE INFO ==================
          {
            table: {
              widths: [120, 5, "*"],
              body: [
                [
                  "Store/ Location",
                  ":",
                  `${this.dataList[0].store} (${this.dataList[0].store_code})`,
                ],
                ["Waktu Mulai", ":", tanggalMulai + " - " + mulaiOpname],
                ["Waktu Selesai", ":", tanggalSelesai + " - " + selesaiOpname],
              ],
            },
            layout: "noBorders",
            margin: [0, 0, 0, 10],
          },

          // =================== MAIN TABLE (fixed) =====================
          {
            table: {
              headerRows: 2,
              widths: [25, 80, 80, 60, 70, 70, 70, 70, 60, 45, 80],

              body: [
                // ---- HEADER ROW 1 (11 cells total)
                [
                  { rowSpan: 2, text: "No", alignment: "center", bold: true }, //1
                  {
                    rowSpan: 2,
                    text: "Brand",
                    alignment: "center",
                    bold: true,
                  }, //2
                  {
                    rowSpan: 2,
                    text: "Category",
                    alignment: "center",
                    bold: true,
                  }, //3
                  { rowSpan: 2, text: "SKU", alignment: "center", bold: true }, //4

                  // colSpan 3 for Stock Awal (this cell + 2 placeholders = 3 columns)
                  {
                    colSpan: 2,
                    text: "Stock Awal 20 Nov 2025",
                    alignment: "center",
                    bold: true,
                  }, //5
                  {}, // placeholder for colSpan (6)
                  {
                    text: `Stock Awal ${tanggalMulaiDate}`,
                    alignment: "center",
                    bold: true,
                  }, // placeholder for colSpan (7)

                  {
                    rowSpan: 2,
                    text: "Stock Hasil Konsolidasi\n[d]",
                    alignment: "center",
                    bold: true,
                  }, //8
                  {
                    rowSpan: 2,
                    text: "Stock Hasil Validasi\n[e]",
                    alignment: "center",
                    bold: true,
                    fillColor: "#ffff99",
                  }, //9
                  {
                    rowSpan: 2,
                    text: "Selisih\n[f]",
                    alignment: "center",
                    bold: true,
                  }, //10
                  {
                    rowSpan: 2,
                    text: "Penjelasan",
                    alignment: "center",
                    bold: true,
                  }, //11
                ],

                // ---- HEADER ROW 2 (11 cells total) — sub-titles for the Stock Awal group

                // ---- HEADER ROW 3 (11 cells total) — labels [a],[b],[c]
                [
                  {}, //1
                  {}, //2
                  {}, //3
                  {}, //4
                  { text: "Odoo\n[a]", alignment: "center" }, //5
                  { text: "Fisik STO\n[b]", alignment: "center" }, //6
                  { text: "Odoo\n[c]", alignment: "center" }, //7
                  { text: "", alignment: "center" }, //8 konsolidasi placeholder
                  { text: "", alignment: "center", fillColor: "#ffff99" }, //9 validasi placeholder (yellow)
                  { text: "", alignment: "center" }, //10 selisih placeholder
                  { text: "", alignment: "center" }, //11 penjelasan placeholder
                ],

                // ==== DATA ROWS (each array MUST have 11 items) ====
                // build rows from dataList ensuring exact 11 values per row
                ...this.dataList.map((item, i) => [
                  { text: i + 1, alignment: "center" }, //1 No
                  item.brand || "", //2 Brand
                  item.category || "", //3 Category
                  item.article || "", //4 SKU
                  item.qty_past !== null ? String(item.qty_past) : "", //5 Stock Awal Odoo [a]
                  item.actual_past !== null ? String(item.actual_past) : "", //6 Fisik STO [b]
                  item.qty !== null ? String(item.qty) : "", //7 Stock Awal 27 Nov [c]
                  item.qty_plan !== null ? String(item.qty_plan) : "", //8 [d]
                  {
                    text:
                      item.actual_qty != null ? String(item.actual_qty) : "",
                    fillColor: "#ffff99",
                  }, //9 [e]
                  item.qty_selisih != null ? String(item.qty_selisih) : "", //10 [f]
                  item.remark || "", //11 Penjelasan
                ]),
              ],
            },
            margin: [0, 10, 0, 10],
          },

          // ================== KETERANGAN + SIGNATURE (SIDE BY SIDE) ===================
          {
            pageBreak: this.dataList.length > 1 ? "before" : undefined,
            columns: [
              // LEFT SIDE: KETERANGAN
              {
                width: "60%",
                stack: [
                  {
                    text: "KETERANGAN :",
                    bold: true,
                    margin: [0, 5, 0, 5],
                  },
                  {
                    ol: [
                      "Stock awal Odoo per Tanggal 20 Nov 2025",
                      "Stock hasil Opname Fisik SPG per Tanggal 20 Nov 2025",
                      `Stock Awal Odoo per Tanggal ${tanggalMulaiDate}, sesuai tanggal visit Task Force`,
                      {
                        text:
                          "Stock Hasil Konsolidasi, adalah kalkulasi by system :\n" +
                          "- Jika [b] ≤ [a], maka [d] = [c]\n" +
                          "- Jika [b] > [a], maka [d] = [c] + ([b]-[a])",
                      },
                      "Diisi oleh Validator sesuai fisik saat visit",
                      "Kalkulasi by system [e] - [d]",
                    ],
                    margin: [0, 0, 20, 10],
                  },
                ],
              },

              // RIGHT SIDE: SIGNATURE BOX
              {
                width: "40%",
                stack: [
                  {
                    text: "Dengan ditandatanganinya Berita Acara ini, para pihak menyatakan bahwa Hasil Validasi Inventory ini telah diperiksa dan disetujui sesuai kondisi sebenarnya pada saat pemeriksaan dilakukan, dan dapat dipertanggung jawabkan untuk tindak lanjut selanjutnya.",
                    alignment: "justify",
                    margin: [0, 5, 0, 20],
                  },

                  {
                    columns: [
                      {
                        width: "50%",
                        stack: [
                          {
                            text: "Validator,",
                            alignment: "center",
                            margin: [0, 10, 0, 80],
                          },
                          {
                            text: `Nama : ${(this.dataList[0].validator_name || "___________________").toUpperCase()}`,
                            alignment: "center",
                          },
                        ],
                      },
                      {
                        width: "50%",
                        stack: [
                          {
                            text: "SPG,",
                            alignment: "center",
                            margin: [0, 10, 0, 80],
                          },
                          {
                            text: `Nama : ${(this.dataList[0].spg_name || "___________________").toUpperCase()}`,
                            alignment: "center",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      };

      const fileName = `validasi_${this.dataList[0].store}_${this.dataList[0].brand}.pdf`;
      pdfMake.createPdf(docDefinition).download(fileName);
    },
  },
};
</script>

<style scoped>
/* Add any custom styles for the button if needed */
button {
  margin-top: 20px;
}
</style>
